var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-footer grid grid__base" }, [
    _c("div", { staticClass: "main-footer--container grid--container" }, [
      _c(
        "div",
        { staticClass: "main-footer--row grid--row" },
        [
          _c(
            "div",
            { staticClass: "grid--col main-footer--logo" },
            [
              _c("app-logo", {
                attrs: { theme: "light", link: { path: "/", label: "home" } }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.plugins, function(plugin, index) {
            return _c(
              plugin.type,
              _vm._b(
                { key: index, tag: "compontent", staticClass: "grid--col" },
                "compontent",
                _vm.bindCmsPluginAttrs(plugin),
                false
              )
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15873738", { render: render, staticRenderFns: staticRenderFns })
  }
}